export const SET_CITIES = '@cities/SET_CITIES';
export const SELECT_FLEET = '@cities/SELECT_FLEET';
